import React, { useEffect, useState } from "react";
import { usePhrase } from "@/contexts/LanguageContext";
import { api, formatINR } from "@/lib/api";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";

export default function GovSchemes() {
  const pt = usePhrase();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/reports/scheme-utilization").then((r) => setRows(r.data || [])); }, []);
  return (
    <div className="space-y-6" data-testid="gov-schemes">
      <div><h1 className="text-3xl font-bold text-slate-900 brand-heading">{pt("Scheme Utilization")}</h1></div>
      <div className="overflow-x-auto table-scroll rounded-lg border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-widest text-slate-500 border-b border-slate-200 bg-slate-50">
            <tr><th className="py-3 px-4">{pt("Scheme")}</th><th className="py-3 px-4">{pt("Cases")}</th><th className="py-3 px-4">{pt("Expected")}</th><th className="py-3 px-4">{pt("Approved")}</th><th className="py-3 px-4">{pt("Received")}</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.scheme_name} className="border-b border-slate-100">
                <td className="py-3 px-4 font-medium">{r.scheme_name}</td>
                <td className="py-3 px-4">{r.count}</td>
                <td className="py-3 px-4">{formatINR(r.total_expected)}</td>
                <td className="py-3 px-4">{formatINR(r.total_approved)}</td>
                <td className="py-3 px-4">{formatINR(r.total_received)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="py-6 text-center text-slate-500">{pt("No scheme utilization data yet.")}</td></tr>}
          </tbody>
        </table>
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
